import { NewsLabels } from 'libs/shared-lib/interfaces/partner-web/news';
import { m030c195CtaImageTeasers, m070c040DealerContact } from '../../shared/shared.de';

export const NEWS_LABELS_DE: NewsLabels = {
    list: {
        headline: 'Aktuelle News',
        showMore: 'Mehr anzeigen',
    },
    detail: {
        m070c040DealerContact,
        m030c195CtaImageTeasers,
        at: 'Bei',
        in: 'in',
        and: 'und',
        region: 'Region',
        andLocation: 'sowie unserem Standort in',
        andLocations: 'sowie unseren Standorten in',
    },
};
